module.exports = __webpack_public_path__ + "static/media/hot-noodles-banner2.aef58d06.png";